import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageTemplateService } from '@app/_components/message/message-template/';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { CalendarModule } from 'primeng/calendar';
import * as moment from 'moment';

@Component({
    selector: 'app-message-template',
    templateUrl: './message-template.component.html',
    styleUrls: ['./message-template.component.css'],
    standalone: false
})
export class MessageTemplateComponent implements OnInit
{

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private messageTemplateService: MessageTemplateService,
        private alertService: AlertService,
        private location: Location,
        private formBuilder: UntypedFormBuilder) { }

    // structure
    subscription: Subscription;
    routerLocation = this.location;


    // data
    messageTemplateApiResponse: ApiResponse;
    messageTemplate;

    // forms
    form1: UntypedFormGroup;
    formLoading = false;
    formAction: String;
    formLabels = [];
    formReadOnly = false;
    messageTemplateId: number;
    createDate: Date;
    lastUpdate: Date;
    name: String;
    description: String;
    subject: String;
    message: String;
    validationMessages = {
        'messageTemplateId': [{}],
        'createDate': [{}],
        'lastUpdate': [{}],
        'name': [
            { type: 'required', message: 'Required' },
            { type: 'maxlength', message: '26 characters maximum' }],
        'description': [
            { type: 'required', message: 'Required' },
            { type: 'maxlength', message: '255 characters maximum' }],
        'subject': [
            { type: 'required', message: 'Required' },
            { type: 'maxlength', message: '99 characters maximum' }],
        'message': [{ type: 'required', message: 'Required' }]
    };


    ngOnInit()
    {

        // formAction
        this.formAction = this.router.url.startsWith('/message-template-add') ? 'add' : this.router.url.startsWith('/message-template-edit') ? 'edit' : this.router.url.startsWith('/message-template-view') ? 'view' : '/';

        /**
         *
         *
         *
         * DATA
         *
        */

        // -------------------------------------------------------------------------------------------------
        // no advanced data handlers
        // -------------------------------------------------------------------------------------------------


        /**
         *
         *
         *
         * ACTIONS (ADD / EDIT / DETAIL)
         *
         */
        try
        {
            // add
            if (this.formAction === 'add')
            {
                this.formLabels['title'] = 'Add New Message Template';
                this.formReadOnly = false;
                this.formBuild();
            }

            // edit
            else if (this.formAction === 'edit')
            {

                this.subscription = this.activatedRoute.params.subscribe(params =>
                {
                    this.messageTemplateId = params.messageTemplateId; // (+) converts string 'id' to a number
                });
                this.formLabels['title'] = 'Edit';
                this.formReadOnly = false;
                this.formBuild();

                // get data
                this.messageTemplate = this.findById(+this.messageTemplateId);

                // patch in data
                this.form1.patchValue(this.messageTemplate);
            }

            // view
            else if (this.formAction === 'view')
            {
                this.subscription = this.activatedRoute.params.subscribe(params =>
                {
                    this.messageTemplateId = params.messageTemplateId; // (+) converts string 'id' to a number
                });
                this.formLabels['title'] = '';
                this.formReadOnly = true;
                this.formBuild();

                // get data
                this.messageTemplate = this.findById(+this.messageTemplateId);

                // patch in data
                this.form1.patchValue(this.messageTemplate);
            }
        }
        catch (error)
        {
            console.log('Error: ' + error);
        }
    }


    formBuild()
    {
        /**
           *
           *
           *
           * FORM
           *
           */

        this.form1 = this.formBuilder.group({
            messageTemplateId: [this.messageTemplateId],
            createDate: [],
            lastUpdate: [],
            name: [],
            description: [],
            subject: [],
            message: []
            // name: ['', Validators.compose([Validators.required, Validators.maxLength(15)])],
            // description: ['', Validators.compose([Validators.required, Validators.maxLength(128)])]
        });
    }


    formAdd()
    {
        try
        {
            // stop here if form is invalid
            if (this.form1.invalid)
            {
                return;
            }

            this.formLoading = true;

            this.messageTemplateService.add(this.form1.value)
                .subscribe(
                    res =>
                    {
                        console.log('message-template-add SUCCESS: ' + JSON.stringify(res));
                        this.messageTemplateId = res.data.messageTemplate.messageTemplateId;
                        this.router.navigate(['/message-template-view', this.messageTemplateId]);
                    },
                    err =>
                    {
                        console.log('message-template-add FAIL: ' + JSON.stringify(err));
                        this.alertService.error(err);
                    },
                    () => { this.formLoading = false; });

        } catch (error)
        {
            this.alertService.error(error);
        }
    }

    formUpdate()
    {
        try
        {
            // stop here if form is invalid
            if (this.form1.invalid)
            {
                return;
            }
            console.log('message-template-before-updateS: ' + JSON.stringify(this.form1.value));
            this.formLoading = true;

            this.messageTemplateService.update(this.form1.value)
                .subscribe(
                    res =>
                    {
                        console.log('message-template-update SUCCESS: ' + JSON.stringify(res));
                        this.alertService.success(res, true);
                        this.router.navigate(['/message-template-view', this.messageTemplateId]);
                    },
                    err =>
                    {
                        console.log('message-template-update FAIL: ' + JSON.stringify(err));
                        this.alertService.error(err);
                    },
                    () => { this.formLoading = false; });
        } catch (error)
        {
            console.log('Form Invalid: ' + JSON.stringify(error));
            this.alertService.error(error);
        }
    }

    findById(id: number)
    {
        try
        {
            this.formLoading = true;
            this.messageTemplateService.findById(id)
                .subscribe(
                    res =>
                    {
                        console.log('message-template-find SUCCESS: ' + JSON.stringify(res));
                        this.messageTemplateApiResponse = res;
                        this.messageTemplate = res.data.messageTemplate;
                        this.form1.patchValue(this.messageTemplate);
                    },
                    err =>
                    {
                        console.log('message-template-find FAIL: ' + JSON.stringify(err));
                        this.alertService.error(err);
                    },
                    () => { this.formLoading = false; });

        } catch (error)
        {
            this.alertService.error(error);
        }
    }
}
